import React from 'react'

const ActualTipsNormalization = ({row}) => {
  
    return <div>{row?.actualTips?.toLocaleString()}</div>;
  
}

export default ActualTipsNormalization